<template>
  <v-row
    id="note"
    class="mt-5 py-2 text-center"
    align="center"
    justify="space-around"
    style="background-color: tomato;"
  >
    <v-btn
      outlined
      small
      color="red lighten-5"
      @click="dialog = !dialog"
    >
      {{ buttonText }}
    </v-btn>
    <v-dialog
      v-model="dialog"
      max-width="380px"
    >
      <v-card>
        <v-card-title class="red--text text--lighten-1">{{ buttonText }}</v-card-title>
        <NoteText></NoteText>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="deep-purple lighten-2"
            text
            @click="dialog = !dialog"
          >
            {{ dialogCloseText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import NoteText from './NoteText'
export default {
  name: 'Note',
  components: {
    NoteText
  },
  data() {
    return {
      buttonText: 'Важная информация',
      dialog: false,
      dialogCloseText: 'Закрыть'
    }
  }
}
</script>

<style lang="scss" scoped>
  #note {
    border-radius: 4px;
  }
</style>